import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Pause, PlayArrow, SkipNext } from "@mui/icons-material";
import { concatParams, CreateParamsJson } from "../../helper/pathHelper";
import {
  describeDrift,
  extendActive,
  finishActive,
  pause,
  resume,
} from "../../helper/liveControls";
import { useLanguage } from "../../i18n/LanguageContext";

// Pause/resume, more time for the running card and "next card now",
// shown under the countdown while a plan is running. Each control writes
// the adjusted plan back into the URL like every other edit.
export default function LiveControls({ isPaused, isRunning }) {
  const json = CreateParamsJson();
  const navigate = useNavigate();
  const location = useLocation();
  const { language, t } = useLanguage();

  if (!isRunning && !isPaused) {
    return null;
  }

  const apply = (change) =>
    navigate({
      pathname: location.pathname,
      search: concatParams(change(json)),
    });
  const drift = describeDrift(json, language);

  return (
    <div className="live-controls">
      <div className="live-controls-buttons">
        <Button
          size="small"
          variant="outlined"
          startIcon={isPaused ? <PlayArrow /> : <Pause />}
          onClick={() => apply(isPaused ? resume : pause)}
        >
          {isPaused ? t("live.resume") : t("live.pause")}
        </Button>
        <Button
          size="small"
          variant="outlined"
          aria-label={t("live.plusOne")}
          disabled={!isRunning}
          onClick={() => apply((params) => extendActive(params, 60))}
        >
          +1
        </Button>
        <Button
          size="small"
          variant="outlined"
          aria-label={t("live.plusFive")}
          disabled={!isRunning}
          onClick={() => apply((params) => extendActive(params, 300))}
        >
          +5
        </Button>
        <Button
          size="small"
          variant="outlined"
          endIcon={<SkipNext />}
          aria-label={t("live.nextLabel")}
          disabled={!isRunning}
          onClick={() => apply(finishActive)}
        >
          {t("live.next")}
        </Button>
      </div>
      {(isPaused || drift) && (
        <div className="live-controls-status" role="status">
          {isPaused && <span className="live-paused">{t("live.paused")}</span>}
          {drift && <span>{drift}</span>}
        </div>
      )}
    </div>
  );
}
